const TableInnerRowsLoading = ({ rows = 5, cols = 5 }) => {
    return (
        <>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <tr key={rowIndex} className="custom_table_row_loading">
                    {Array.from({ length: cols }).map((_, colIndex) => (
                        <td key={colIndex} className="custom_table_td_loading">
                            <div className="custom_table_td_loading_inner"></div>
                        </td>
                    ))}
                </tr>
            ))}
        </>
    );
};

export default TableInnerRowsLoading;